
export interface InverterApi {
  id: string;
  manufacturer: string;
  name: string;
  baseUrl: string;
  apiKey: string;
  username?: string;
  password?: string;
  isActive: boolean;
  lastSync?: string;
  createdAt: string;
  notes?: string;
}

export const inverterManufacturers = [
  "Deye",
  "SAJ",
  "Growatt",
  "Chint",
  "Solis",
  "Sofar",
  "Huawei",
  "SMA",
  "Fronius",
  "GoodWe",
  "Canadian Solar",
  "ABB",
  "Delta",
  "Enphase",
  "SolarEdge",
  "Outro"
];

export interface ApiFormValues {
  manufacturer: string;
  name: string;
  baseUrl: string;
  apiKey: string;
  username?: string;
  password?: string;
  isActive: boolean;
  notes?: string;
}
